<template>
  <side-panel-inner on-close="AdminAlertsIndex" :headerTitle="headerTitle">
    <template slot="actions" v-if="!loading">
      <base-button :primary="true" @click="handleSubmit">Save</base-button>
    </template>
    <loading v-if="loading" />
    <div v-else>
      <message type='warning'>
        <p>{{ this.editMode ? 'Editing ' : 'Creating '}}this alert will set it as the active alert, and will be instantly visible to all users.</p>
      </message>
      <form @submit.prevent="handleSubmit" class="add-comment">
        <form-field full-width label="Title" name="title" type="text" v-model="currentAlert.title" />

        <form-field
          full-width
          label="Description"
          name="description"
          type="textarea"
          v-model="currentAlert.description"
        />

        <form-toggle
          v-model="currentAlert.persistent"
          @toggle="updatePersistent"
          label="Make Persistent? "
        />
      </form>
    </div>
  </side-panel-inner>
</template>

<script>
import { mapState } from "vuex";
const TextArea = () => import("@/components/forms/TextArea");
import { FormToggle } from "@/components/forms";
export default {
  name: "AlertAddEdit",
  computed: {
    ...mapState("Alerts", ["currentAlert"]),
    headerTitle() {
      return this.editMode ? "Edit Alert" : "Create Alert";
    }
  },
  data() {
    return {
      editMode: false,
      loading: true
    };
  },
  components: {
    TextArea,
    FormToggle
  },
  created() {
    if (this.$route.params.id) {
      this.$store
        .dispatch("Alerts/getAlert", this.$route.params.id)
        .then(resp => {
          this.editMode = true;
          this.loading = false;
        });
    } else {
      this.$store.commit('Alerts/RESET_ALERT');
      this.loading = false;
    }
  },
  methods: {
    updatePersistent() {
      this.currentAlert.persistent = !this.currentAlert.persistent;
    },
    handleSubmit() {
      let action = "Alerts/saveAlert";
      let payload = { payload: this.currentAlert };

      if (this.editMode) {
        action = "Alerts/updateAlert";
        let editPayload = (({ title, description, persistent }) => ({
          title,
          description,
          persistent
        }))(this.currentAlert);

        payload = { payload: editPayload, id: this.$route.params.id };
      }

      this.$store
        .dispatch(action, payload)
        .then(resp => {
          this.$store.dispatch("CLOSE_PANEL");
          this.$store.dispatch(
            "notifications/create",
            {
              body: `The alert has been added`,
              type: "success"
            },
            { root: true }
          );
          console.log("success", resp);
        })
        .catch(err => {
          console.log("error", err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>